import React from 'react';
import PropTypes from 'prop-types';
import Datatable from '../../../common/datatable';
import {history} from '../../../../store';

const columns = [
  {
    prop: 'name',
    title: 'Name'
  },
  {
    prop: 'uid',
    title: 'Auth token'
  },
  {
    prop: 'revoke-api-access',
    title: 'Access revoked'
  },
];

const actions = [
  {
    label: 'Edit',
    callback: (row) => {
      history.push(`/admin/user-access-tokens/${row.id}/edit`);
    },
    permissions: {
      action: 'modify',
      subjectClass: 'DeviceToken',
    }
  },
];

const AccessTokenTable = ({
  tokens, paging, currentPage, onPageChange
}) => {
  const {number, size} = paging;
  const dataSize = number * size;
  const pagination = {
    page: currentPage,
    sizePerPage: size,
    onPageChange,
  };

  return (
    <div>
      <Datatable
        actions={actions}
        columns={columns}
        data={tokens}
        dataSize={dataSize}
        pagination={pagination}
        remote
        hideId
      />
    </div>
  );
};

AccessTokenTable.propTypes = {
  tokens: PropTypes.array.isRequired,
  paging: PropTypes.shape({
    number: PropTypes.number,
    size: PropTypes.number,
  }),
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default AccessTokenTable;



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/access-token-table.jsx